import { CANCELED, DELIVERED, EXPIRED, GIFT_CLAIMED, IN_FULFILLMENT, SHIPPED } from './reports';

export const NON_CANCELING_STATUSES = [GIFT_CLAIMED, CANCELED, SHIPPED, DELIVERED, IN_FULFILLMENT, EXPIRED];
